import NiotaClassicApiService from '@/services/niotaClassicApiService';
import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
export default {
  name: 'NiotaClassicCommonAccountFilter',
  props: {
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    initiallySelected: {
      type: Array,
      required: false,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    n1Accounts: {
      type: Boolean,
      required: false,
      default: false
    },
    showResetButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function () {
    return {
      accounts: [],
      accountsSearchQuery: null,
      selectedAccounts: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    singleButton() {
      return this.iconOnly && !this.showResetButton;
    },
    accountsQueryResult() {
      if (this.accountsSearchQuery) {
        const filtered = this.accounts.filter(item => {
          return this.accountsSearchQuery.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v));
        });
        return this.selectedAccounts.filter(item => {
          return filtered.findIndex(fAcc => fAcc.id === item.id) < 0;
        }).concat(filtered);
      } else {
        return this.accounts;
      }
    },
    listSelection() {
      if (this.multiple) {
        return this.accountIndizes;
      }
      return get(this.accountIndizes, '[0]');
    },
    accountIndizes() {
      return this.accountsQueryResult.map((account, index) => {
        if (this.selectedAccounts.findIndex(a => a.id === account.id) >= 0) {
          return index;
        }
        return null;
      }).filter(a => a !== null);
    },
    accountId() {
      return get(this.selectedAccounts, '[0].id');
    }
  },
  watch: {
    initiallySelected() {
      this.initSelection();
    }
  },
  mounted() {
    this.fetchAccountPlain();
  },
  methods: {
    fetchAccountPlain() {
      let promise = null;
      if (this.n1Accounts) {
        promise = NiotaClassicApiService.accountsFetchPlain().then(response => {
          this.accounts = response.data.accounts;
          this.initSelection();
          this.$emit('accounts-loaded');
        });
      } else {
        promise = ApiService.tenantFetchAll().then(res => {
          this.accounts = res.tenants;
          this.initSelection();
          this.$emit('accounts-loaded');
        });
      }
      promise.catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
        this.$emit('accounts-loaded');
        console.error(error);
      });
    },
    initSelection() {
      if (this.initiallySelected.length && this.accounts.length) {
        let selectedAccounts = [];
        this.accounts.map(item => {
          if (this.initiallySelected.includes(item.id)) {
            item.selected = true;
            selectedAccounts.push(item);
          }
        });
        // do not cause an endless loop here if `initiallySelected` is updated on the embedding component
        if (!isEqual(this.selectedAccounts, selectedAccounts)) {
          this.selectedAccounts = selectedAccounts;
          this.$emit('selected', this.selectedAccounts);
        }
      }
    },
    clickedAccount(idx, account) {
      // if the current account is not yet in the indizes-list it was obviously just selected
      const didSelect = this.accountIndizes.indexOf(idx) < 0;
      this.clickedAccountCheckbox(didSelect, account);
    },
    clickedAccountCheckbox(event, account) {
      if (!this.multiple && this.accountIndizes.length > 0) {
        this.selectedAccounts = [];
      }
      account.selected = event;
      if (event) {
        this.selectedAccounts.push(account);
      } else {
        this.selectedAccounts.splice(this.selectedAccounts.findIndex(selectedAccount => selectedAccount.id === account.id), 1);
      }
      this.$emit('selected', this.selectedAccounts);
    }
  }
};